(function () {
  if (window.__decantLimitInit) return;
  window.__decantLimitInit = true;

  var cfg = window.DecantLimitConfig || {};
  var MAX = parseInt(cfg.max, 10) || 3;
  var MSG = (cfg.msg || 'Puedes llevar máximo [max] decants de 5 mL de cada perfume.').replace('[max]', MAX);

  // Revy Discounts recarga la página después de cada cambio del carrito (add/change/update),
  // así que el aviso y el contador de intentos viajan en sessionStorage entre recargas.
  var STORE_KEY = 'decantLimitState';
  var STATE_TTL = 15000;
  var MAX_ATTEMPTS = 3; // tope de recortes seguidos: evita un bucle de recargas si /cart/change falla

  var running = false;
  var pending = false;
  var timer = null;
  var observer = null;
  var openOnLoad = false;
  // product_id de los decants recortados: su línea muestra el aviso.
  var noticeProducts = {};

  function readState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (s && Date.now() - s.t < STATE_TTL) return s;
    } catch (e) {}
    return null;
  }

  function writeState(s) {
    try {
      if (s) {
        s.t = Date.now();
        sessionStorage.setItem(STORE_KEY, JSON.stringify(s));
      } else {
        sessionStorage.removeItem(STORE_KEY);
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function cartJsUrl() {
    return ((window.routes && window.routes.cart_url) || '/cart') + '.js';
  }

  function changeJsUrl() {
    return ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';
  }

  function isDecant(item) {
    var sku = (item.sku || '').toLowerCase();
    if (sku.indexOf('5ml-decant') !== -1) return true;
    return /(^|\D)5\s?ml\s*$/i.test((item.product_title || '').trim());
  }

  function getCart() {
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function onCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  // Líneas a recortar: por perfume (product_id) se permiten MAX unidades en total.
  function excess(cart) {
    var used = {};
    var changes = [];
    (cart.items || []).forEach(function (item) {
      if (!isDecant(item)) return;
      var already = used[item.product_id] || 0;
      var keep = Math.min(item.quantity, Math.max(0, MAX - already));
      used[item.product_id] = already + keep;
      if (keep < item.quantity) changes.push({ key: item.key, quantity: keep, productId: String(item.product_id) });
    });
    return changes;
  }

  function renderDrawer(drawer, state) {
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.getSectionsToRender().forEach(function (section) {
      var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!el || !state.sections || !state.sections[section.id]) return;
      var html = drawer.getSectionInnerHTML(state.sections[section.id], section.selector);
      if (section.id === 'cart-drawer') html = html.replace(/loading=(["'])lazy\1/g, 'loading="eager"');
      el.innerHTML = html;
    });
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  // Tras la recarga de Revy: el HTML del drawer puede venir de antes del recorte,
  // así que se vuelve a pedir y se abre para que el cliente vea el aviso.
  async function refreshAndOpenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.getSectionsToRender || onCartPage()) return;
    try {
      var ids = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      var sections = await fetch(window.location.pathname + '?sections=' + ids.join(',')).then(function (r) {
        return r.json();
      });
      renderDrawer(drawer, { sections: sections });
    } catch (e) {}
    drawer.open();
  }

  // Tope en los inputs del carrito (el "+" se deshabilita en MAX) y aviso por línea.
  function markCart(cart) {
    var decantVariants = {};
    var lineByProduct = {};
    (cart.items || []).forEach(function (item, i) {
      if (!isDecant(item)) return;
      decantVariants[item.variant_id] = true;
      if (!lineByProduct[item.product_id]) lineByProduct[item.product_id] = i + 1;
    });

    document.querySelectorAll('.quantity__input[data-quantity-variant-id]').forEach(function (input) {
      if (!decantVariants[input.dataset.quantityVariantId]) return;
      // Si la línea ya está sobre el tope (checkout bloqueado), no se pone max: Dawn
      // rechazaría el "-" hacia un valor aún mayor que MAX y el cliente no podría bajar.
      if (parseInt(input.value, 10) > MAX) return;
      if (input.getAttribute('max') !== String(MAX)) input.setAttribute('max', MAX);
      var qi = input.closest('quantity-input');
      if (qi && qi.validateQtyRules) qi.validateQtyRules();
    });

    // En /cart conviven la página del carrito y el drawer (oculto): se escribe en ambos.
    Object.keys(noticeProducts).forEach(function (productId) {
      var line = lineByProduct[productId];
      if (!line) return;
      ['CartDrawer-LineItemError-' + line, 'Line-item-error-' + line].forEach(function (id) {
        var box = document.getElementById(id);
        var text = box && box.querySelector('.cart-item__error-text');
        if (text && text.textContent !== MSG) text.textContent = MSG;
      });
    });

    if (observer) observer.takeRecords();
  }

  function markProductPage() {
    if (!cfg.pdpIsDecant) return;
    document.querySelectorAll('product-info quantity-input input[name="quantity"]').forEach(function (input) {
      if (input.getAttribute('max') !== String(MAX)) input.setAttribute('max', MAX);
      var qi = input.closest('quantity-input');
      if (qi && qi.validateQtyRules) qi.validateQtyRules();
    });
  }

  function setCheckoutBlocked(blocked) {
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (blocked) {
        b.disabled = true;
        b.dataset.decantBlocked = 'true';
      } else if (b.dataset.decantBlocked) {
        b.disabled = false;
        delete b.dataset.decantBlocked;
      }
    });
  }

  async function enforce() {
    if (running) {
      pending = true;
      return;
    }
    running = true;
    try {
      var cart = await getCart();
      var changes = excess(cart);

      if (!changes.length) {
        writeState(null);
        setCheckoutBlocked(false);
        if (openOnLoad) {
          openOnLoad = false;
          await refreshAndOpenDrawer();
        }
        markCart(cart);
        return;
      }

      var st = readState() || { ids: [], attempts: 0 };
      changes.forEach(function (c) {
        noticeProducts[c.productId] = true;
        if (st.ids.indexOf(c.productId) === -1) st.ids.push(c.productId);
      });
      st.attempts += 1;
      // Sin sessionStorage no hay cómo contar intentos entre recargas: no se recorta, solo se bloquea el checkout.
      if (st.attempts > MAX_ATTEMPTS || !writeState(st)) {
        setCheckoutBlocked(true);
        markCart(cart);
        return;
      }

      var drawer = document.querySelector('cart-drawer');
      var cartPage = onCartPage();
      var state = null;
      try {
        for (var i = 0; i < changes.length; i++) {
          var body = { id: changes[i].key, quantity: changes[i].quantity };
          if (i === changes.length - 1 && drawer && drawer.getSectionsToRender && !cartPage) {
            body.sections = drawer.getSectionsToRender().map(function (s) {
              return s.id;
            });
            body.sections_url = window.location.pathname;
          }
          var res = await fetch(changeJsUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          if (!res.ok) throw new Error('cart/change ' + res.status);
          state = await res.json();
        }
      } catch (e) {
        // No se pudo recortar: se bloquea el checkout hasta que el carrito quede dentro del tope.
        setCheckoutBlocked(true);
        markCart(cart);
        return;
      }

      if (cartPage) {
        window.location.reload();
        return;
      }
      // Sin Revy la página no se recarga: se pinta el drawer acá.
      if (drawer && state && state.sections) renderDrawer(drawer, state);
      setCheckoutBlocked(false);
      markCart(state && state.items ? state : cart);
    } catch (e) {
      // Si falla la lectura del carrito no se toca nada.
    } finally {
      running = false;
      if (pending) {
        pending = false;
        schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(enforce, 200);
  }

  function init() {
    var st = readState();
    if (st && st.ids) {
      st.ids.forEach(function (id) {
        noticeProducts[id] = true;
      });
      openOnLoad = true;
    }

    markProductPage();
    schedule();

    // Cambios hechos por el cliente (agregar, +/-, eliminar): se limpia el aviso y se revisa.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        noticeProducts = {};
        schedule();
      });
    }

    // Re-render del drawer o del carrito por cualquier vía (links de campaña, apps).
    observer = new MutationObserver(schedule);
    ['cart-drawer', '#main-cart-items'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
